import { request } from '@blade/common';
// 获取人像库
export const getPortraitlibApi = () => request.post('/api/portrait-management/api/v1/portraitlib/list', {});
// 获取设备树
export const getDeviceTreeApi = () => request.post('/api/iot-device-management/api/v1/iot/devices/facade/iot/tree', {});
// 添加考勤管理规则
export const addRuleApi = (data) => request.post('/api/access-management/api/v1/attendance/rule/add', data);
// 获取回显的规则
export const getRuleApi = () => request.post('/api/access-management/api/v1/attendance/rule/list', {});
// 更新考勤管理规则
export const updateRuleApi = (data) => request.post('/api/access-management/api/v1/attendance/rule/update', data);
